import moment from 'moment';
import 'moment-range';

export const getDaysRange = (start, end) => moment.range(start, end).toArray('days');

export const defaultRange = (range = 'year', startDate = null, endDate = null, format = 'DD-MM-YYYY') => {
  const start = startDate ?
    moment(startDate, format) :
    moment();
  const end = endDate ?
    moment(endDate, format) :
    moment();
  return getDaysRange(start.startOf(range), end.endOf(range));
};

export const getYearsRange = (startDate, endDate, format) =>
  defaultRange('year', startDate, endDate, format);

export const getMonthsRange = (startDate, endDate, format) =>
  defaultRange('month', startDate, endDate, format);

export const getWeeksRange = (startDate, endDate, format) =>
  defaultRange('week', startDate, endDate, format);

export const getDayRange = (startDate, endDate, format) =>
  defaultRange('days', startDate, endDate, format);

export const getYears = (startYear) => {
  const start = moment([startYear.year() - 50, 0]),
    end = moment([startYear.year() + 50, 0]);

  return moment.range(start, end).toArray('years');
};

export const getWeekDays = (lang) => {
  const days = [];

  moment.locale(lang);

  for (let i = 0; i < 7; i += 1) {
    days.push(moment().weekday(i).format('dd'));
  }

  return days;
};

export default class Month {
  constructor(month, year) {
    this.start = moment([year, month]);
    this.end = this.start.clone().endOf('month');
    this.month = month;
    this.year = year;
  }

  getWeekStart() {
    return this.start.weekday();
  }

  getDays() {
    const start = this.start;
    return getDaysRange(start, this.end);
  }

  getFormatted() {
    return this.start.format('MMMM YYYY');
  }

  getWeeks() {
    return this.end.week() - this.start.week() + 1; // eslint-disable-line
  }

  getYears() {
    return getYears(this.start);
  }
}



// WEBPACK FOOTER //
// ./src/common/functions/month.js